export const habaCart = {
  habaAddToCartPopup: {
    headline: 'Article ajouté au panier',
    toCart: 'Voir le panier',
    continue: 'Continuer mes achats',
    recommendationsTitle: 'Produits susceptibles de vous intéresser',
    add: 'Ajouter',
    added: 'Ajouté',
    quantity: 'Quantité :',
  },

  habaVoucher: {
    coupon: "Vous avez un bon d'achat ou un numéro d'avantage?",
    apply: 'Encaisser',
    placeholder: 'Saisir un numéro',
    error: 'Veuillez saisir un numéro de bon',
    applyVoucherSuccess: '{{voucherCode}} a été encaissé avec succès.',
    removeVoucherSuccess: '{{voucherCode}} a été supprimé.',
    availableCoupons: 'Coupons utilisables',
    availableCouponsLabel: 'Tu peux ajouter ces coupons à ta commande.',
    vouchersApplied: "Bons d'achat utilisés:",
    promotionInfo: {
      headline: 'Informations et conditions',
      labelPromo: "Code d'avantage",
      labelCampaign: 'Campagne',
    },
    giftCardInsolvencyInputMessageFindMore: 'Tu trouveras ici de plus amples informations.',
    giftCardInsolvencyClose: 'Fermer',
    giftCardInsolvencySorryMessage: 'Nous sommes désolés!',
    giftCardInsolvencyMessage1:
      "Notre entreprise fait actuellement l'objet d'une procédure d'insolvabilité et d'auto-administration.",
    giftCardInsolvencyMessage2: 'Si votre carte cadeau a été achetée avant le 12.09.2023, ',
    giftCardInsolvencyMessage3:
      'le solde fait partie de la procédure et ne peut malheureusement pas être remboursé pour le moment.',
    giftCardInsolvencyMessage4:
      'En guise de petite excuse, nous avons ajouté une réduction spéciale à ton panier.',
    giftCardInsolvencyMessage5:
      "Après l'ouverture de la procédure d'autogestion (prévue pour le 01.12.2023), tu pourras déclarer et faire valoir ta créance dans le tableau d'insolvabilité.",
    disabledGiftcardsMessage:
      'Malheureusement, les codes de réduction et les bons ne peuvent pas être utilisés actuellement. La fonction sera à nouveau disponible prochainement.',
  },
  habaMiniCart: {
    cart: 'Votre panier',
    emptyCart: "Panier d'achat vide.",
    viewCart: 'Voir le panier',
    anonymousPopup: {
      headline: 'Tes produits te manquent-ils ?',
      text: 'Connecte-toi pour voir tes derniers produits dans le panier.',
      headlineHaba: 'Vos produits vous manquent?',
      textHaba:
        "Connectez-vous à votre compte et bénéficiez d'un traitement plus rapide des commandes et d'offres spéciales.",
      button: "S'inscrire",
    },
    emptyCartPopupText: "Tu n' as pas d'article dans ton panier.",
    emptyCartPopupTextHaba: "Vous n'avez pas d'article dans votre panier",
  },
  habaCart: {
    emptyCartTitle: 'Votre panier',
    emptyCartDescription:
      'Ajoutez des produits à votre panier en parcourant la boutique et en ajoutant des articles au panier.',
    emptyCartButtonText: 'Commencer à fouiller',
    myCart: 'Mon panier',
    toHome: "Vers la page d'accueil",
    payPalExpressInfo: 'Payer & commander rapidement avec',
    backToCart: 'Retour au panier',
  },
  cartProductReplaceErrors: {
    quantityReduced:
      "Malheureusement, la quantité souhaitée n'est plus disponible. La quantité maximale disponible a été ajustée.",
    maxOrderQuantityExceeded:
      'Les quantités demandées ne sont plus disponibles. Quantités modifiées.',
    productNotFound: "Malheureusement, le produit n'est pas disponible.",
    lowStock: "Nous sommes désolés, mais le produit que vous avez demandé n'est plus disponible.",
  },
};
